import { ElementRef } from '@angular/core';
import { TelemetryEvent } from '../../utilities/insights/models/telemetry-event';

export class ClickEvent extends TelemetryEvent {
	constructor(data: ClickEventProps) {
		super('click');
		this.context.target = data?.targetElement?.nativeElement?.id;
	}
}

export interface ClickEventProps {
	targetElement: ElementRef;
}


